import React, { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Tabs } from '@veneer/core';

import { useDependencyManagerContext } from '../../contexts/dependencyManager';
import {
  getDeviceSharingRequestsRequest,
  getDeviceSharingRequestsCleanup
} from '../../features/shared-access/shared-access-slice';
import DeviceDetailsViewer from '../device-details-viewer';
import SharedAccess from '../shared-access';

const MY_DEVICES_TAB_ID = 'my-devices';
const SHARED_ACCESS_TAB_ID = 'shared-access';
const SESSION_STORAGE_KEY = 'device-tabs-selected-tab';

const DeviceTabs: React.FC = () => {
  const { translate } = useDependencyManagerContext();
  const dispatch = useDispatch();
  const [selectedTabId, setSelectedTabId] = useState<string>(
    () => sessionStorage.getItem(SESSION_STORAGE_KEY) ?? MY_DEVICES_TAB_ID
  );

  useEffect(() => {
    dispatch(getDeviceSharingRequestsRequest());
    return () => {
      dispatch(getDeviceSharingRequestsCleanup());
    };
  }, [dispatch]);

  const handleChangeTab = (id: string) => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, id);
    setSelectedTabId(id);
  };

  const isSharedAccessActive = selectedTabId === SHARED_ACCESS_TAB_ID;

  const tabs = [
    {
      id: MY_DEVICES_TAB_ID,
      label: translate('components.device-tabs.my-devices'),
      content: <DeviceDetailsViewer />
    },
    {
      id: SHARED_ACCESS_TAB_ID,
      label: translate('components.device-tabs.shared-access'),
      content: <SharedAccess isActive={isSharedAccessActive} />
    }
  ];

  return (
    <Tabs
      data-testid="react-device-management-mfe-device-tabs"
      tabs={tabs}
      selectedTabId={selectedTabId}
      onChangeTab={handleChangeTab}
      type="online"
      mode="extended"
      controlId="device-tabs"
      keepMounted
    />
  );
};

export default memo(DeviceTabs);
